'use client';

import type { AttributesEntity } from '@eliadmin/core/src/api/products/types/product-types';
import { useCategoryStore } from '@eliadmin/core/src/stores/category-store';
import { useCategoryFilterActions } from '@/hooks/use-category-filter-actions';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export function CategoryFilterSelect({ attribute }: { attribute: AttributesEntity }) {
  const filterAttributes = useCategoryStore(s => s.filter.attributes);
  const { setFilter } = useCategoryFilterActions();

  const activeEntry = filterAttributes.find(a => a.id === attribute.id);
  const selectedId = activeEntry?.values[0];
  const selectedStr = selectedId != null ? String(selectedId) : '';

  const sortedValues = [...(attribute.values ?? [])].sort(
    (a, b) => (a.position ?? 0) - (b.position ?? 0),
  );

  const handleChange = (val: string) => {
    const value = attribute.values?.find(v => String(v.id) === val);
    if (!value) return;
    setFilter({ selectedValue: { attribute, value }, replace: true });
  };

  return (
    <Select value={selectedStr} onValueChange={handleChange}>
      <SelectTrigger className="h-12 whitespace-nowrap rounded-[4px] bg-primary-foreground px-4 text-sm font-normal text-primary lg:px-6">
        <SelectValue placeholder={attribute.name} />
      </SelectTrigger>
      <SelectContent
        align="center"
        alignOffset={6}
        className="rounded-[4px] border border-border shadow-none"
      >
        {sortedValues.map(v => (
          <SelectItem key={v.id} value={String(v.id)} className="rounded-[4px]">
            {v.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
